module.exports = __webpack_public_path__ + "com_index_6bg.jpg?a138ad4bda1e9afe1bcd9b619cbafcee";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_6bg.jpg
// module id = 54
// module chunks = 0